import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CloseModal } from '../modal.models';
import { Observable } from 'rxjs';
import { selectApplicantParticularFullAddress } from 'src/app/state/selectors/pre-application.selectors';
import { Store } from '@ngrx/store';
import { selectApprovedCard } from 'src/app/state/selectors/tdc-application.selector';
import { TdcCard } from 'src/app/models/tdc/tdc-evaluation.model';

type CardType = 1 | 2;

const CardTypes: Map<CardType, string> = new Map([
	[1, './assets/images/tdc/tarjeta-clasica.svg'],
	[2, './assets/images/tdc/tarjeta-oro.svg'],
]);

@Component({
	selector: 'cmv-tdc-ship-notice-modal',
	templateUrl: './tdc-ship-notice-modal.component.html',
	styleUrls: ['./tdc-ship-notice-modal.component.scss'],
})
export class TdcShipNoticeModalComponent implements CloseModal {
	@Input() cardWithName: boolean;
	@Input() name: string;
	@Input() isModalOpen: boolean;
	@Input() isCreditCard: boolean = true;

	@Output() closeModalEvent: EventEmitter<void> = new EventEmitter();

	applicantParticularAddress$: Observable<string> = this.store.select(
		selectApplicantParticularFullAddress
	);
	tdcCard$: Observable<TdcCard> = this.store.select(selectApprovedCard);

	constructor(private store: Store) {}

	onCloseModal(): void {
		this.closeModalEvent.emit();
	}

	get classicTdcPathImg(): string {
		return CardTypes.get(1);
	}

	get goldTdcPathImg(): string {
		return CardTypes.get(2);
	}

	get debitCardPathImg(): string {
		return './assets/images/tdd/tarjeta-tdd.svg';
	}

	get nameLabel(): string {
		return this.cardWithName ? this.name : '';
	}

	get deliveryTimeLabel(): string {
		if (this.isCreditCard) {
			return this.cardWithName
				? 'Recibirás en tu domicilio una tarjeta de crédito en un máximo de 10 días.'
				: 'Podrás recoger tu tarjeta de crédito en la sucursal más cercana de forma inmediata.';
		} else {
			return 'Podrás recoger tu tarjeta de débito en la sucursal donde estás registrado. La entrega es inmediata.';
		}
	}
}
